<script setup lang="ts">
const store = useStore()
const cartStore = useCartStore()
const { modal } = storeToRefs(store)
const { status } = useAuth()
const { isEmpty, roundedProductsQuantity } = storeToRefs(cartStore)

const loginLink = computed(() => status.value === 'authenticated'
  ? { text: 'Moje konto', link: '/u/moje-konto' }
  : { text: 'Zaloguj się', link: '/u/logowanie' }
)
</script>

<template>
  <div>
    <Modal v-if="modal.type === 'MobileMenu'">
      <MenuMobileMenu />
    </Modal>
    <Modal v-else-if="modal.type === 'Search'">
      <MenuSearch :mobile="true" />
    </Modal>
    <Modal v-else-if="modal.type === 'Contact'">
      <MenuContact :mobile="true" />
    </Modal>
    <div class="fixed bottom-0 left-0 w-full z-10 lg:hidden">
      <div class="flex justify-around items-center bg-white text-10 h-[52px] border-t border-solid border-gray-400">
        <NuxtLink to="/" class="flex flex-col gap-[5px] justify-center items-center h-full" @click="store.getModal(false, null)">
          <i class="icon-home text-[15px]" />
          <span>Strona główna</span>
        </NuxtLink>
        <div :class="modal.name === 'Menu' ? 'open' : ''" class="menu flex flex-col gap-[5px] justify-center items-center h-full border-t-2 border-solid border-transparent" @click="store.getModal('MobileMenu', 'Menu')">
          <i class="icon-menu text-[15px]" />
          <span>Menu</span>
        </div>
        <NuxtLink to="/rezerwacja" class="flex flex-col gap-[5px] justify-center items-center h-full">
          <i class="icon-calendar text-[15px]" />
          <span>Zarezerwuj</span>
        </NuxtLink>
        <NuxtLink :to="loginLink.link" class="flex flex-col gap-[5px] justify-center items-center h-full">
          <i class="icon-zaloguj-sie text-[15px]" />
          <span>{{ loginLink.text }}</span>
        </NuxtLink>
        <NuxtLink to="/koszyk" class="flex flex-col gap-[5px] justify-center items-center h-full">
          <span class="relative">
            <Transition enter-active-class="animate-zoom-in" leave-active-class="animate-zoom-out">
              <Badge v-if="!isEmpty" class="absolute bg-primary text-white top-[calc(-50%+2px)] -right-1/2">
                {{ roundedProductsQuantity }}
              </Badge>
            </Transition>
            <i class="icon-shop text-[15px]" />
          </span>
          <span>Koszyk</span>
        </NuxtLink>
        <div :class="modal.name === 'Kontakt' ? 'open' : ''" class="menu flex flex-col gap-[5px] justify-center items-center h-full border-t-2 border-solid border-transparent" @click="store.getModal('Contact', 'Kontakt')">
          <i class="icon-phone text-[15px]" />
          <span>Kontakt</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.menu {
  &.open {
    @apply text-primary;
    @apply border-primary;
  }
}
</style>
